<template>
  <div class="prize-container">
    <img
      v-if="activityInfo.activity_crowd == 1"
      class="bg-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/f844bfbe077ebc8f9e7054a5e231733a_wh=543_114.png"
      alt=""
    />
    <img
      v-else
      class="bg-image bg-image-1"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/3c06fece61f3fd391f6f7e4972aa0088_wh=336_120.png"
      alt=""
    />
    <div class="top">
      <div
        class="my-prize"
        @click="bindMyPrize"
        v-if="[1, 2].includes(activityInfo.activity_crowd)"
        ><span>{{
          activityInfo.activity_crowd == 1 ? '我的奖品：' : '我的奖品'
        }}</span
        ><span class="num" v-if="activityInfo.activity_crowd == 1">{{
          myPrizeList.length
        }}</span
        ><span class="iconfont icon-you"></span
      ></div>
    </div>
    <div class="prize-wrapper" v-if="activityData && activityData.reward_list">
      <!-- <div class="prize-list">
          <div
            class="prize-item"
            v-for="(item, index) in activityData.reward_list"
            :key="index"
          >
            <img class="prize-image" :src="item.reward_image" alt="" />
          </div>
        </div> -->

      <!--  <PaoMaDeng :prizes="activityData.reward_list"></PaoMaDeng> -->
      <PaoMaDeng
        :list="activityData.reward_list"
        :step="activityData.reward_list.length < 5 ? 0 : 0.7"
      >
        <div class="prize-list">
          <div
            class="prize-item"
            v-for="(item, index) in activityData.reward_list"
            :key="index"
          >
            <img class="prize-image" :src="item.reward_image" alt="" />
          </div>
        </div>
      </PaoMaDeng>
    </div>
    <div
      class="draw-btn"
      @click="bindLottery"
      v-if="
        activityInfo.activity_crowd == 2 && activityInfo.activity_state == 1
      "
      :class="{ 'draw-btn-disabled': !activityData.surplus_raffle_num }"
    >
      <div>点击抽奖</div>
      <div class="draw-count" v-if="activityData.surplus_raffle_num"
        >剩余{{ activityData.surplus_raffle_num }}次机会</div
      >
    </div>
  </div>
</template>
<script>
import PaoMaDeng from './paomadeng.vue'
export default {
  components: { PaoMaDeng },
  data() {
    return {}
  },
  computed: {
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    },
    activityData() {
      return this.$store.state.coachActivity2024.activityData
    },
    myPrizeList() {
      return this.$store.state.coachActivity2024.myPrizePage.prizeList
    }
  },
  created() {},
  methods: {
    bindMyPrize() {
      if (this.activityInfo.activity_state != 2) {
        this.$store.commit('coachActivity2024/setMyPrizeToast', true)
      } else {
        this.$toast('活动未开始')
      }
    },

    async bindLottery() {
      if (this.activityInfo.activity_state != 1) {
        return
      }
      if (!this.activityData.surplus_raffle_num) {
        this.$toast('你没有抽奖次数了哦~')
        return
      }
      let res = await this.$http
        .getApp('api/v1/AnnualCoach/notMemberRaffle')
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$store.commit('coachActivity2024/setLotteryData', res.data)
          this.$store.commit('coachActivity2024/setLotteryToast', true)
          this.$store.dispatch('coachActivity2024/actionPrizeList')
          this.$store.dispatch('coachActivity2024/actionActivityIndex')
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.prize-container {
  position: relative;
  width: 355px;
  margin: 0 auto;
  background: linear-gradient(175deg, #fff8e0 0px, #ffffff 72px, #ffffff 182px);
  box-shadow: 0px 0px 6px 0px rgba(253, 120, 186, 0.1);
  border-radius: 8px;
  border: 1px solid #ffffff;
  overflow: hidden;
  padding-bottom: 10px;
  .bg-image {
    position: absolute;
    width: 181px;
    height: 38px;
    left: 14px;
    top: 15px;
  }
  .bg-image-1 {
    width: 112px;
    height: 40px;
  }
  .top {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    height: 44px;
    padding: 0px 14px;
    margin-bottom: 24px;
    .my-prize {
      height: 28px;
      border-radius: 16px;
      border: 1px solid rgba(255, 34, 112, 0.5);
      font-weight: bold;
      font-size: 14px;
      color: #ff2270;
      padding: 0px 11px 0px 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      .num {
        font-family: DIN;
        font-weight: bold;
        font-size: 20px;
        color: #ff2270;
        margin-right: 8px;
      }
      .iconfont {
        font-size: 16px;
      }
    }
  }
  .prize-wrapper {
    overflow-x: scroll;
    .prize-list {
      display: inline-flex;
      padding-left: 10px;
      align-items: center;
      .prize-item {
        margin-right: 10px;
        .prize-image {
          box-sizing: border-box;
          width: 70px;
          height: 70px;
          background: #fffafc;
          border-radius: 5px;
          overflow: hidden;
          border: 1px solid #ffd5e4;
        }
        .prize-name {
          text-align: center;
          white-space: nowrap;
          font-weight: bold;
          font-size: 11px;
          color: #303038;
          line-height: 16px;
        }
      }
      .prize-item:last-child {
        margin-right: 0px;
      }
    }
  }
  .draw-btn {
    position: relative;
    width: 298px;
    height: 44px;
    margin: 20px auto 0 auto;
    background: linear-gradient(287deg, #fc3c87 0%, #fe285e 58%, #fc5c72 100%);
    border-radius: 22px;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    .draw-count {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(0%, -50%);
      box-sizing: border-box;
      height: 22px;
      background: #fffa88;
      border-radius: 13px 13px 13px 0px;
      border: 1px solid #ffffff;
      line-height: 20px;
      padding: 0px 10px;
      font-weight: bold;
      font-size: 13px;
      color: #ff2270;
    }
  }
  .draw-btn-disabled {
    opacity: 0.3;
  }
}
</style>
